<div class="page-content-padding page-content-max-width w-full pt-20 lg:pt-[200px]">
  <div class="w-full flex justify-between items-center mb-12 flex-wrap gap-4">
    <div class="flex flex-col gap-3">
      <h1 class="text-neon text-xl uppercase">
        {{ 'event.upcoming.cant_attend_now' | translate }}
      </h1>
      <p class="text-white">{{ 'event.upcoming.what_is_coming' | translate }}</p>
    </div>
    <k-button
      class="max-sm:hidden"
      [gtagLabel]="'to_all_events'"
      [routerLink]="['/events']"
      [icon]="'north_east'"
      [outlined]="true">
      {{ 'event.upcoming.to_all_events' | translate }}
    </k-button>
  </div>

  @if (loadingSig()) {
    <div class="w-full h-[30svh] flex items-center justify-center relative">
      <k-loading
        type="spinner"
        size="medium"></k-loading>
    </div>
  } @else {
    <div class="grid grid-cols-4 max-xl:grid-cols-2 max-sm:grid-cols-1 text-white gap-8">
      @for (item of upcomingSig(); track item.id) {
        <k-photo-card
          [data]="getCardData(item)"
          [clickable]="true"
          [showChipOnImage]="false"
          [aspectRatio]="'square'"
          (cardClick)="navigateToEvent(item.slug)"></k-photo-card>
      }
    </div>
  }

  <div class="flex w-full justify-center mt-12">
    <k-button
      class="sm:hidden w-full"
      [fullWidth]="true"
      [gtagLabel]="'to_all_events'"
      [routerLink]="['/events']"
      [icon]="'north_east'"
      [outlined]="true">
      {{ 'event.upcoming.to_all_events' | translate }}
    </k-button>
  </div>
</div>
